import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { Element } from '../../../common/html/element'
import { Panel } from '../../../common/panel'
import { formatText } from '../../../helpers/value'
import { COMPONENTS } from '../../../routers/constants'
import { LabelPanel } from '../common/LabelPanel'
import { RightPanel } from '../common/RightPanel'
import { ALERT_TYPE_CODE } from '../constant'
import { selectCompanyInfo } from '../store/slice'
import { CapitalOwnership } from './CapitalOwnership'
import { Management } from './Management'
import classes from './index.module.scss'

export const ChangeTable = ({ data, detailKey }) => {
  const { organizationId } = useSelector(selectCompanyInfo)

  const detailData = data[detailKey]

  const isManagement = detailKey === ALERT_TYPE_CODE.MANAGEMENTCHANGE.dataKey

  const linkTo = isManagement
    ? COMPONENTS.companyAnalysis.components.companyProfile.route
    : COMPONENTS.companyAnalysis.components.ownershipAndGroup.route

  return (
    <Panel
      renderLabel={() => <LabelPanel data={data} detailData={detailData} />}
      renderRightHeader={() => <RightPanel data={data} detailKey={detailKey} />}
    >
      <Element className={classes.description} style={{ fontSize: 14 }}>
        {formatText(detailData?.description)}
      </Element>
      <Element className={classes.content} style={{ color: '#3A414B' }}>
        <Element
          className={classes.contentItem}
          style={{ backgroundColor: '#F3F3F3' }}
        >
          <Element
            className={classes.header}
            style={{ fontSize: 14, backgroundColor: '#BCBCBC' }}
          >
            <Translate value="alertDetail.PREVIOUS" />
          </Element>
          <div className={classes.table}>
            {isManagement ? (
              <Management
                data={detailData?.managementChange
                  ?.map((item) => item.previous)
                  .filter(Boolean)}
              />
            ) : (
              <CapitalOwnership
                data={detailData?.ownershipChange
                  ?.map((item) => item.previous)
                  .filter(Boolean)
                  .sort((a, b) => b?.percentage - a?.percentage)}
              />
            )}
          </div>
        </Element>
        <Element
          className={classes.contentItem}
          style={{ backgroundColor: '#F3F3F3' }}
        >
          <Element
            className={classes.header}
            style={{ fontSize: 14, backgroundColor: '#BCBCBC' }}
          >
            <Translate value="alertDetail.CURRENT" />
          </Element>
          <div className={classes.table}>
            {isManagement ? (
              <Management
                data={detailData?.managementChange
                  ?.map((item) => item.current)
                  .filter(Boolean)}
              />
            ) : (
              <CapitalOwnership
                data={detailData?.ownershipChange
                  ?.map((item) => item.current)
                  .filter(Boolean)
                  .sort((a, b) => b?.percentage - a?.percentage)}
              />
            )}
          </div>
        </Element>
      </Element>

      <Element className="textCenter my1" style={{ color: '#3A414B' }}>
        <Element elementName="span" style={{ color: '#2C73E8' }}>
          <Link
            to={`${linkTo}?organizationId=${organizationId}`}
            target="_blank"
          >
            <Translate value="alertDetail.CLICK_HERE" />
          </Link>
        </Element>
        &nbsp;
        <Translate value="alertDetail.FOR_MORE_INFORMATION" />
      </Element>
    </Panel>
  )
}
